/**
 * Check if field label is string or JSON
 * JSON fields map to translation keys
 *
 * @param {string|Object|undefined} fieldLabel
 * @param {string} fieldLabel.header
 * @param {string} fieldLabel.sub_header
 *
 * @returns {string|Object|null}
 */
export const parseFieldLabel = fieldLabel => {
  if (!fieldLabel) return null;
  if (typeof fieldLabel !== "string") return null;
  try {
    const json = JSON.parse(fieldLabel);
    if (json && typeof json === "object" && !Array.isArray(json)) {
      return json;
    }

    if (Array.isArray(json)) {
      return null;
    }

    return fieldLabel;
  } catch {
    return fieldLabel;
  }
};
